import request from '@/api/request'

/**
 * 领取证书管理列表（超管）
 * @param
 */
 export const receiveCertificateList = (data) => {
  return request({
    url: '/product/adm/userTestPlan/receiveCertificateList',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 领取证书管理列表（教务服务方）
 * @param
 */
 export const receiveCertificateListByAgent = (data) => {
  return request({
    url: '/product/adm/userTestPlan/receiveCertificateListByAgent',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 导入
 * @param
 */
 export const importCertificate = (data) => {
  return request({
    url: '/product/adm/userTestPlan/importCertificate',
    method: 'post',
    data
  })
}
/**
 * 获取教务服务方列表
 * @param
 */
 export const getCompanyByPid = (params) => {
  return request({
    url: '/base/adm/company/getCompanyByPid',
    method: 'get',
    type: 'json',
    params
  })
}
/**
 * 套打证书申请列表（超管）
 * @param
 */
 export const getListPagePrint = (data) => {
  return request({
    url: '/product/adm/printApply/getListPage',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 套打证书申请列表（教务服务方）
 * @param
 */
 export const getListPageByAgentPrint = (data) => {
  return request({
    url: '/product/adm/printApply/getListPageByAgent',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 未套打申请列表
 * @param
 */
 export const getUnPrintList = (data) => {
  return request({
    url: '/product/adm/userSku/getUnPrintList',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 证书打印池/补打申请列表
 * @param
 */
 export const getTDListPage = (data) => {
  return request({
    url: '/product/adm/userSkuCertificate/getTDListPage',
    method: 'post',
    type: 'json',
    data
  })
}

export const getPrintList = (data) => {
  return request({
    url: '/product/adm/userSkuCertificate/getListPage',
    method: 'post',
    type: 'json',
    data
  })
}

export const getPrintListByAgent = (data) => {
  return request({
    url: '/product/adm/userSkuCertificate/getListPageByAgent',
    method: 'post',
    type: 'json',
    data
  })
}




/**
 * 提交证书套打（补打）申请
 * @param
 */
 export const addApply = (data) => {
  return request({
    url: '/product/adm/printApply/addApply',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 教务服务方套打申请的时候判断是否有待审核的
 * @param
 */
 export const judgeApply = (data) => {
  return request({
    url: '/product/adm/printApply/judgeApply',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 证书套打（补打）申请详情
 * @param
 */
 export const getListPageAudit = (data) => {
  return request({
    url: '/product/adm/printApplyItem/getListPage',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 证书套打（补打）申请审核
 * @param
 */
 export const printApplyAudit = (data) => {
  return request({
    url: '/product/adm/printApply/audit',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 证书申领记录
 * @param
 */
 export const getListPageApply = (data) => {
  return request({
    url: '/product/adm/certificateApply/getListPage',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 证书申领记录(教务服务方)
 * @param
 */
 export const getListPageByAgent = (data) => {
  return request({
    url: '/product/adm/certificateApply/getListPageByAgent',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 获取申领上限和下拉框的数据
 * @param
 */
 export const getApplyMaxNum = (data) => {
  return request({
    url: '/product/adm/certificateApply/getApplyMaxNum',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 查询申领状态
 * @param
 */
 export const judgeApply1 = (data) => {
  return request({
    url: '/product/adm/certificateApply/judgeApply',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 添加申领
 * @param
 */
 export const addCertificateApply = (data) => {
  return request({
    url: '/product/adm/certificateApply/addCertificateApply',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 编辑申领
 * @param
 */
 export const updateCertificateApply = (data) => {
  return request({
    url: '/product/adm/certificateApply/updateCertificateApply',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 教务服务方申领记录上面的统计
 * @param
 */
 export const getStatisticsData = (data) => {
  return request({
    url: '/product/adm/certificateApply/getStatisticsData',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 申领审核
 * @param
 */
 export const auditApply = (data) => {
  return request({
    url: '/product/adm/certificateApply/audit',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 申领审核修改发送状态
 * @param
 */
 export const updateExpressState = (data) => {
  return request({
    url: '/product/adm/certificateApply/updateExpressState',
    method: 'post',
    type: 'json',
    data
  })
}
